export const INSIGHTS_PACKAGE = 'servicedesk.insights';
export const INSIGHTS_BOARD_PACKAGE = `${INSIGHTS_PACKAGE}.board`;
export const INSIGHTS_BOARD_SIMPLIFIED_PACKAGE = `${INSIGHTS_PACKAGE}.board-simplified`;
export const BOARD_BUTTON_ID = `${INSIGHTS_PACKAGE}.board-button`;
export const INSIGHTS_PANEL_BOUNDARY_ID = `${INSIGHTS_PACKAGE}.error-boundary`;
